import { push } from 'react-router-redux';
import { ApiService } from 'services';
import { clearDefaultForm } from 'actions';
import { handleException } from 'actions/exceptions';
import { HANDLE_UNCAUGHT_EXCEPTION } from 'actions/exceptions/handleUncaughtException';

export const ADD_FORM_GROUP_REQUEST = 'ADD_FORM_GROUP_REQUEST';
export const ADD_FORM_GROUP_SUCCESS = 'ADD_FORM_GROUP_SUCCESS';
export const ADD_FORM_GROUP_FAILURE = 'ADD_FORM_GROUP_FAILURE';

function request(formGroup) {
  return {
    type: ADD_FORM_GROUP_REQUEST,
    isAddingFormGroup: formGroup
  };
}

function receive(collectableSupportingDocs) {
  return {
    type: ADD_FORM_GROUP_SUCCESS,
    accCollectableSupportingDocs: collectableSupportingDocs
  };
}

function reject(error) {
  return {
    type: HANDLE_UNCAUGHT_EXCEPTION,
    code: error.code,
    message: error.message
  };
}

export function addFormGroup(formTypes, accountId, formGroup) {
  const postData = {
    isOnline: true,
    accountId,
    formTypes
  };

  return (dispatch) => {
    dispatch(request(formTypes));

    const promise = () => ApiService
      .addFormGroup(postData)
      .then((response) => {
        if (response.data && response.data.success && response.data.formGroupId > 0) {
          const formUrl = `/forms/groups/${ formGroup }/${ response.data.formGroupId }`;
          dispatch(receive(response.data.collectableSupportingDocs));
          dispatch(clearDefaultForm(formUrl));
          return dispatch(push(formUrl));
        }

        dispatch({ type: ADD_FORM_GROUP_FAILURE });
        if (response.data && response.data.error) {
          return dispatch(reject(response.data.error));
        }

        return dispatch(reject({
          code: '-9999',
          message: 'Sorry, there was an unexpected error communicating with our servers'
        }));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch({ type: ADD_FORM_GROUP_FAILURE });
          if (error.response.status !== 403) {
            dispatch(handleException(error, reject));
          }
        }
      });

    return promise();
  };
}
